import React from 'react';
import PropTypes from 'prop-types';
import { C } from 'shared/helpers';

import Styles from './Section.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons';

const Section = ({ icon, toggle, title, open, children, ...props }) => {
  const { Section, Header, Icon, Open } = Styles;
  return (
    <div className={C(Section, [open, Open])}>
      <div onClick={toggle} className={Header} {...props}>
        <h4>
          <span className={Icon}>
            <FontAwesomeIcon icon={icon} />
          </span>
          {title}
          <span className={C([open, Open])}>
            <FontAwesomeIcon icon={faAngleDown} />
          </span>
        </h4>
      </div>
      {children}
    </div>
  );
};

Section.propTypes = {
  children: PropTypes.node.isRequired,
  icon: PropTypes.any.isRequired,
  toggle: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
};

export default Section;
